const utils = {
  isWeiXin: () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("micromessenger");
  },
  isMobileDevice: () => {
    return window.innerWidth <= 768;
  },
  isIOS: () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  },
};

export default utils;
